import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import Translator from "../../Translation/Translator";

export default function* chargeUndoCredit(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_CHARGE_UNDO_CREDIT_REQUEST
    });

    yield call(Http.put, `charge/${action.payload?.charge?.id}/uncredit`);

    yield put({
      type: Constants.GLOBAL_CHARGE_UNDO_CREDIT_SUCCESS
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-charge-undo-credit-successfully"),
        type: "success"
      }
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_CHARGE_UNDO_CREDIT_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargeUndoCredit() {
  yield takeEvery(Constants.GLOBAL_CHARGE_UNDO_CREDIT_START, chargeUndoCredit);
}
